function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_686",
  "data-name": "Group 686",
  transform: "translate(-9.741 -11.401)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_638",
  "data-name": "Group 638",
  transform: "translate(-2996.327 -3397.946)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_515",
  "data-name": "Group 515",
  transform: "translate(3006.569 3423.342)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_577",
  "data-name": "Path 577",
  d: "M57.556,50.4c6.659-.537,11.667-2.846,11.667-5.614,0-1.875-2.3-3.539-5.849-4.585",
  transform: "translate(-39.964 -40.202)",
  fill: "none",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_578",
  "data-name": "Path 578",
  d: "M17.711,40.2c-3.552,1.046-5.85,2.71-5.85,4.585,0,2.768,5.008,5.078,11.667,5.614",
  transform: "translate(-11.861 -40.202)",
  fill: "none",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_579",
  "data-name": "Path 579",
  d: "M39.132,61.362l1.7,2.287-2.287,1.7",
  transform: "translate(-28.271 -53.216)",
  fill: "none",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_660",
  "data-name": "Path 660",
  d: "M675.495,22.243a16.415,16.415,0,0,0-2.048-3.792.394.394,0,0,0-.21-.14l-1.618-.436.169-1.424v-.01a2.719,2.719,0,0,0-.191-1.279l-.055-.134a2.7,2.7,0,0,0-1.986-1.632.655.655,0,0,0-.191,0,2.7,2.7,0,0,0-1.986,1.632l-.055.133a2.72,2.72,0,0,0-.191,1.279v.01l.169,1.424-1.617.436a.394.394,0,0,0-.21.14,16.412,16.412,0,0,0-2.048,3.792,10.847,10.847,0,0,0-.185,8.193l.189,1.113a.394.394,0,0,0,.388.328h1.356a.394.394,0,0,0,.392-.359l.109-1.219.148-1.267.148.657a.394.394,0,0,0,.384.307h6.206a.394.394,0,0,0,.384-.307l.148-.657.148,1.267.109,1.219a.394.394,0,0,0,.392.359H675.1a.394.394,0,0,0,.388-.328l.189-1.113A10.848,10.848,0,0,0,675.495,22.243Zm-7.463-6.263a.386.386,0,0,0,.059-.018l.2-.085a2.917,2.917,0,0,1,2.463.046l.072.034a.386.386,0,0,0,.112.032c-.049,1.125-.844,2.9-1.452,2.9S668.078,17.1,668.032,15.98Zm1.431-1.8a1.916,1.916,0,0,1,1.207.862,3.71,3.71,0,0,0-2.418.006A1.917,1.917,0,0,1,669.463,14.18ZM664.9,30.213v.011l-.077.866h-.663l-.141-.831a.4.4,0,0,0-.026-.089c-1.854-4.327.613-8.925,1.673-10.59l-.35,7.083Zm7.353-1h-5.576L666.1,26.66l.383-7.748,1.357-.366a.389.389,0,0,0,.137-.069c.377.678.888,1.2,1.506,1.2a1.91,1.91,0,0,0,1.5-1.177.391.391,0,0,0,.107.048l1.332.359.408,7.755Zm2.686.96a.389.389,0,0,0-.026.089l-.141.831h-.663l-.077-.866v-.011l-.414-3.552-.375-7.12C674.286,21.173,676.806,25.809,674.938,30.169Z",
  transform: "translate(-644.533 -1.988)",
  fill: "#ffffff"
}));

var SvgFlip = function SvgFlip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.259,
    height: 26.825,
    viewBox: "0 0 30.259 26.825",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flip.aa2c1422.svg";
export { ForwardRef as ReactComponent };